const isFetching = (entityName) => ({
  [`${entityName}ItemListFetching`]: (state) => state.fetching[entityName].isItemListFetching,
  [`${entityName}ItemFetching`]: (state) => state.fetching[entityName].isItemFetching,
  [`${entityName}PaginatedListFetching`]: (state) =>
    state.fetching[entityName].isPaginatedListFetching,
  [`${entityName}FilteredListFetching`]: (state) =>
    state.fetching[entityName].isFilteredListFetching,
  [`${entityName}UpdateFetching`]: (state) => state.fetching[entityName].isUpdateFetching,
  [`${entityName}CreateFetching`]: (state) => state.fetching[entityName].isCreateFetching,
  [`${entityName}DeleteFetching`]: (state) => state.fetching[entityName].isDeleteFetching,
  [`${entityName}PartialEntityFetching`]: (state) =>
    state.fetching[entityName].isPartialEntityFetching,
  [`${entityName}FetchingDates`]: (state) => state.fetching[entityName].fetchingDates,
});

export const fetchingSelectors = {
  ...isFetching('products'),
  ...isFetching('users'),
  ...isFetching('properties'),
  ...isFetching('categories'),
  ...isFetching('facilities'),
  ...isFetching('spaTreatments'),
  ...isFetching('spaDays'),
  ...isFetching('pages'),
  ...isFetching('categories'),
  ...isFetching('spaClasses'),
  ...isFetching('spaPackages'),
};
